import React, { Component } from "react"
import { Grid } from "@material-ui/core"
import { Link } from "gatsby"
import styled from "@emotion/styled"
import GridWrapper from "../../atoms/GridWrapper"
import RowGrid from "../../atoms/RowGrid"
import LinkTexts from "./PCHeaderLink"
import HText from "../../atoms/LinkText"
import { colors } from "../../constants"

const Text = styled(HText)(
  {
    fontFamily: "cursive",
  },
  props => ({
    fontSize: props.fontSize,
    textAlign: props.textAlign,
    textDecoration: props.textDecoration,
    color: props.color,
    fontWeight: props.fontWeight,
  })
)

const HGrid = styled(Grid)({
  padding: "0 10px",
  "@media (max-width:540px)": {
    padding: "0 5px",
  },
})

export default class Top extends Component {
  render() {
    return (
      <GridWrapper height={80}>
        <RowGrid container>
          <HGrid item xs={4} style={{ textAlign: "left", paddingLeft: "20px" }}>
            <Text fontSize={30} color={colors.brand} to={"/"}>
              Katahira Seminar
            </Text>
          </HGrid>
          <Grid item xs={8} style={{ textAlign: "right", padding: "0 20px" }}>
            <LinkTexts />
          </Grid>
        </RowGrid>
      </GridWrapper>
    )
  }
}
